const SubjectBoxHW = ({ subname, sublogo, started, progress, complateed }) => {
  return (
    <div
      className="py-1 px-3 text-center shadow-sm rounded-4 mb-1 "
      style={{
        minWidth: "250px",
        maxWidth: "350px",
        backgroundColor: "#FDEFE3",
        borderTop: "2px solid #8D4B28", // top border
        borderRight: "4px solid #8D4B28", // right border (thicker)
        borderBottom: "1px solid #8D4B28",
        borderLeft: "1px solid #8D4B28",
        borderRadius: "0.75rem",
      }}
    >
      <div className="d-flex flex-column align-items-center mb-1">
        <img src={sublogo} alt={subname} style={{ height: "32px" }} />
        <h6
          className="mt-1 fw-bold text-brown mx-auto text-truncate poppins-semibold"
          title={subname}
          style={{
            maxWidth: "100%", // allows truncation to work
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            hover: "pointer",
            color: "#8D4B28",
          }}
        >
          {subname && subname?.length > 15
            ? subname?.slice(0, 20) + "…"
            : subname}
        </h6>
      </div>

      <div className="d-flex justify-content-between gap-2 border-top pt-2 text-muted small fw-semibold ">
        <div className=" d-flex flex-column ">
          <small className="text-sm poppins-semibold ">Published</small>
          <small className="text-dark poppins-semibold">
            {started === 0 ? started : String(started).padStart(2, "0")}
          </small>
        </div>

        <div className=" d-flex flex-column border-start border-end border-dark border-2 px-1">
          <small className="text-nowrap poppins-semibold">On Review</small>
          <small className="text-dark poppins-semibold">
            {progress === 0 ? progress : String(progress).padStart(2, "0")}
          </small>
        </div>

        <div className=" d-flex flex-column">
          <small className="poppins-semibold">Completed</small>
          <small className="text-dark poppins-semibold">
            {complateed === 0
              ? complateed
              : String(complateed).padStart(2, "0")}
          </small>
        </div>
      </div>
    </div>
  );
};

export default SubjectBoxHW;
